import DapDSAvatar from './avatar.component'

export * from './avatar.component'
export default DapDSAvatar

DapDSAvatar.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-avatar': DapDSAvatar
  }
}
